import React from 'react'

function Thankyou() {
  return (
    <>
    <div>Thankyou</div>
    <div className='mb-6'>
        <h3 className='text-lg font-semibold mb-2'> Thank You </h3>
       
    </div>
    </>
  )
}

export default Thankyou